var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPenCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0080A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 33V28.75L28.2 15.575C28.4 15.3917 28.6208 15.25 28.8625 15.15C29.1042 15.05 29.3583 15 29.625 15C29.8917 15 30.15 15.05 30.4 15.15C30.65 15.25 30.8667 15.4 31.05 15.6L32.425 17C32.625 17.1833 32.7708 17.4 32.8625 17.65C32.9542 17.9 33 18.15 33 18.4C33 18.6667 32.9542 18.9208 32.8625 19.1625C32.7708 19.4042 32.625 19.625 32.425 19.825L19.25 33H15ZM29.6 19.8L31 18.4L29.6 17L28.2 18.4L29.6 19.8Z",
    fill: "#E9FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenCircle);
export default __webpack_public_path__ + "static/media/edit-pen-circle.0770b9a961a31a20e481d9c28ef8cd81.svg";
export { ForwardRef as ReactComponent };